import type { UpdateUserRequest, UserDetailed } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

export function updateUserDetails(userId: string, formData: UpdateUserRequest): Promise<UserDetailed> {
  return requestApiJsonOrThrow<UserDetailed>(`admin/users/${userId}`, {
    method: 'PATCH',
    body: formData,
  })
}
